import { contractorsActions } from "_store/contractors.slice";
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { ContractorMainDetails } from "./Extensions/ContractorDetails/ContractorMainDetails";
import AddressesDetails from "./Extensions/ContractorDetails/AddressesDetails";
import ContactPersonListDetails from "./Extensions/ContractorDetails/ContactPersonsDetails";
import { IntermediaryListDetails } from "./Extensions/ContractorDetails/IntermediaryListDetails";
import { DomainButton } from "_components/Abstractions/DomainButton";
import { ChangeContractorState } from "./ChangeContractorState";
import { ContractorBdoDetails } from "./Extensions/ContractorDetails/ContractorBdoDetails";
import { BackButton } from "../../_components/Abstractions/BackButton";
import { useToast } from "../../_helpers/notifications/useToasts";
import { ContractorPricingOffcanvas } from "./Extensions/CreateContractor/ContractorRatePlans/ContractorRatePlanForm";
import { ContractorRatePlansDetails } from "./Extensions/ContractorDetails/ContractorRatePlansDetails";
import { IntermediaryManagedContractorsDetails } from "./Extensions/ContractorDetails/IntermediaryManagedContractorsDetails";

export function ContractorDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { showErrorMessage } = useToast();
  const { contractorData } = useGetContractorDetails({ id });

  useEffect(() => {
    if(contractorData?.error) {
      showErrorMessage("Nie udało się pobrać danych kontrahenta, spróbuj ponownie...");
    }
  }, [contractorData])

  const Actions = (
    <div className="mb-2">
      <BackButton
        className="me-1"
        link="/configuration"
      >Powrót do listy klientów
      </BackButton>
      {contractorData && <>
        <DomainButton
          className="me-1"
          disabled={contractorData?.isLoading}
          onClick={() =>
            navigate(`/contractors/${id}/update`, {
              state: { contractor: contractorData }
            })
          }
        >
          Edytuj klienta
        </DomainButton>
        <ContractorPricingOffcanvas contractorId={id} contractorTypes={contractorData?.contractorTypes} intermediaries={contractorData?.intermediaries} addresses={contractorData?.addresses} btnTitle="Dodaj cennik"/>
        <ChangeContractorState
          contractor={contractorData}
          detailsUpdate
        />
      </>}
    </div>
  );

  return (
    <div className="container">
      {contractorData?.isLoading && <div className="spinner-border"></div>}
      {!contractorData?.isLoading && Actions}
      {contractorData && <>
        <ContractorMainDetails contractorData={contractorData}/>
        <IntermediaryListDetails contractorTypes={contractorData.contractorTypes} intermediaries={contractorData?.intermediaries}/>
        <IntermediaryManagedContractorsDetails contractorTypes={contractorData?.contractorTypes} managedContractors={contractorData?.managedContractors} />
        <ContractorBdoDetails contractorTypes={contractorData?.contractorTypes} isBdoLinked={contractorData?.isBdoLinked} bdoDetails={contractorData?.bdoDetails}/>
        <AddressesDetails contractorId={id} contractorTypes={contractorData?.contractorTypes} addresses={contractorData?.addresses}/>
        <ContractorRatePlansDetails/>
        <ContactPersonListDetails contactPersons={contractorData?.contactPersons}/>
      </>}
    </div>
  );
}


export function useGetContractorDetails({ id }) {
  const dispatch = useDispatch();
  const { contractorData } = useSelector(x => x.contractors);
  const getContractorById = useCallback(async ({ id, token }) => {
    dispatch(contractorsActions.getById({ id, token }));
  }, []);

  useEffect(() => {
    const abortController = new AbortController();
    const token = abortController.signal;

    getContractorById({ id, token });

    return () => {
      if(process.env.REACT_APP_ENVIROMENT === "Development") { return; }
      abortController.abort();
    };
  }, [id, getContractorById]);

  return { contractorData, getContractorById };
}